/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AutoComplete, Button, Input, Select } from 'antd';
import './ReceptionInfo.less';
import { useAuth } from '@isocel/front-common';

import { useStoreByOrganization } from '../../../queries/store';
import { PackagingFlowDirection, Store } from '../../../queries/api/types';
import { usePackagingFlow } from '../../../context/PackagingFlowContext';
import { getPackingFlowFromStore, validateTransportVoucher } from '../../../queries/api/packaging-flow';
import { useNotification } from '../../notification/Notification';
import { usePalettes } from '../../../queries/palette';

const { Option } = Select;

const ReceptionInfo: React.FC = () => {
    const [store, setStore] = useState<Store>({
        name: '',
        id: '',
        code: '',
        organization: '',
    });
    const [options, setOptions] = useState<Store[]>([]);
    const { showNotification } = useNotification();
    const history = useHistory();
    const {
        setSelectedStore,
        selectedParc,
        setSelectedParc,
        parcPalettes,
        setParcPalettes,
        setPackageFlow,
        voucher,
        setVoucher,
        setFlowType,
        reset,
    } = usePackagingFlow();
    const { user } = useAuth();
    const { data: palettesData } = usePalettes(user?.organization?.id || '');
    const { data: stores } = useStoreByOrganization(user?.organization?.id ?? '');

    useEffect(() => {
        reset();
        if (palettesData?.length === 1) {
            setSelectedParc(palettesData[0]);
        }
        setParcPalettes(palettesData || []);
    }, [setParcPalettes, palettesData]);

    const handleSearch = (value: string) => {
        const filtered = value
            ? (stores || []).filter((store) => store.name.toLowerCase().includes(value.toLowerCase()))
            : stores || [];
        setOptions(filtered.map((store) => ({ ...store, value: `${store.code} - ${store.name}` })));
    };

    const handleSelect = (value: string, option: Store) => {
        setStore({ ...store, name: value, id: option.id });
    };

    const handleClear = () => {
        setStore({ ...store });
    };
    const handleVoucherChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVoucher(e.target.value);
    };

    const handleParcChange = (value: string) => {
        const parc = parcPalettes.find((p) => p.name === value) || null;
        setSelectedParc(parc);
    };

    const sendRequest = async () => {
        try {
            const validateVoucher = await validateTransportVoucher(voucher, 3, store.id);
            if (validateVoucher.voucherFound === true) {
                showNotification(
                    'error',
                    'Erreur',
                    "Un flux de rendus d'emballages a déjà été créé pour ce bon de transport."
                );
                return;
            } else {
                setSelectedStore(store);
                setFlowType(PackagingFlowDirection.RecivedInOrganization);
                const fetchAndSetLoadingSessionsPackage = async (storeId: string, voucher: string) => {
                    try {
                        const response = await getPackingFlowFromStore(storeId, voucher);
                        if (response) {
                            setPackageFlow(response);
                            history.push(`/recipientMovement/${storeId}`);
                        } else {
                            setPackageFlow(null);
                            history.push(`/recipientTrack/${storeId}`);
                        }
                    } catch (error) {
                        history.push(`/recipientTrack/${storeId}`);
                        setPackageFlow(null);
                        console.error('Error fetching loading sessions packages:', error);
                    }
                };
                setVoucher(voucher);
                if (store.id && voucher) {
                    fetchAndSetLoadingSessionsPackage(store.id, voucher);
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };
    return (
        <>
            <div className="reception-info-container">
                <h2 className="reception-info-title">Veuillez saisir le magasin</h2>
                <form className="reception-info-form">
                    <div className="form-field">
                        <label htmlFor="recipientLabel">Libelle magasin</label>
                        <br />
                        <AutoComplete
                            id="recipientLabel"
                            className="w-full"
                            options={options}
                            onSearch={handleSearch}
                            notFoundContent="Aucun résultat"
                            onSelect={handleSelect}
                            onChange={(value) => {
                                if (!value) handleClear();
                            }}
                            placeholder="Tapez pour rechercher..."
                            onDropdownVisibleChange={(open) => {
                                if (open) {
                                    handleSearch('');
                                }
                            }}
                        />
                    </div>
                    <div className="form-field">
                        <label htmlFor="transportNumber">N° de bon de transport</label>
                        <br />
                        <Input
                            id="transportNumber"
                            placeholder="Exemple : 389911024"
                            className="input-field"
                            onChange={handleVoucherChange}
                        />
                    </div>
                    <div className="form-field">
                        <label htmlFor="parcs">Parc palettes</label>
                        {palettesData?.length === 1 ? (
                            <Input value={palettesData[0].name} className="dropdown-input" />
                        ) : (
                            <Select
                                id="parcs"
                                placeholder="Choisir le parc palettes"
                                value={selectedParc?.name}
                                notFoundContent="Aucun résultat"
                                onChange={handleParcChange}
                                className="dropdown-input"
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {parcPalettes.map((parc) => (
                                    <Option key={parc.id} value={parc.name}>
                                        {parc.name}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </div>
                    <div className="form-submit">
                        <Button
                            type="primary"
                            disabled={!store.name || !voucher || !selectedParc}
                            onClick={sendRequest}
                        >
                            Suivant
                        </Button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default ReceptionInfo;
